import React from 'react'
import { MdOutlineArrowLeft } from "react-icons/md";


const Services = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
              We Offer you for your special days
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/">
                  <p className="text-blue-700 ">Back</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            {/* <p class="lg:w-1/2 w-full leading-relaxed text-gray-500">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p> */}
          </div>
          <div class="flex flex-wrap -m-4">
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\Weddings.jpeg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">SUBTITLE</h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  WEDDING
                </h2>
                <p class="leading-relaxed text-base">
                  Steps above the main dining room, this lavish space is
                  available for exclusive use each evening.
                </p>
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\BIRTHDAYS.jpg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">
                  SUBTITLE
                </h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  BIRTHDAYS
                </h2>
                <p class="leading-relaxed text-base">
                  A festive birthday event space with opulent interior for any
                  more than thousand guests.
                </p>
                <br />
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\HOME CEREMONY.jpg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">
                  SUBTITLE
                </h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  HOME CEREMONY
                </h2>
                <p class="leading-relaxed text-base">
                  Elevate your home ceremony with a tantalizing array of
                  flavors, personalized menus, and impeccable service.
                </p>
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\REUNION.jpg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">
                  SUBTITLE
                </h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  REUNION
                </h2>
                <p class="leading-relaxed text-base">
                  A huge space for family or friends reunions
                </p>
                <br /> <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services